import { InjectionToken } from '@angular/core';
import { Environment } from './environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
